import React from 'react';
import { Typography, Divider } from '@mui/material';
import classes from './PageHeader.module.scss';

interface IPageHeaderProps {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  actions?: React.ReactNode;
  showDivider?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  subtitle,
  actions,
  showDivider = true,
  className = '',
  children,
}) => {
  return (
    <div className={`${classes.pageHeader} ${className}`}>
      <div className={classes.headerContent}>
        <div className={classes.titleSection}>
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>

          {subtitle && (
            <Typography variant="body1" className={classes.subtitle}>
              {subtitle}
            </Typography>
          )}

          {children}
        </div>
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>

      {showDivider && <Divider className={classes.divider} />}
    </div>
  );
};

export default PageHeader;
